import React from 'react';
import classes from './ConnectInstagramModal.module.scss';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { Button } from '../../../../components/actions/Button';
import { ReactComponent as InstagramIcon } from '../../../../assets/images/InstagramIcon.svg';
import { ReactComponent as FacebookIcon } from '../../../../assets/images/facebookIcon.svg';
import classNames from 'classnames';
import { Void } from '../../../../models/basic-objects';
import { Tooltip } from '../../../../components/actions/Tooltip';
import scssVars from '../../../../assets/scss/exportedVars.module.scss';
import { idGenerator } from '../../../../helpers/idGenerator';
import { IgModalActionEnum } from '../Profiles.controller';

type DecisionBoxProps = {
  title: string;
  pros: string[];
  cons: string[];
  tooltip: string;
  network: 'Facebook' | 'Instagram';
  actionType: IgModalActionEnum;
  action: Void;
};

export const DecisionBox = ({
  title,
  pros,
  cons,
  network,
  actionType,
  action,
  tooltip
}: DecisionBoxProps): JSX.Element => {
  const decisionBoxClasses = classNames('margin-top-small-12', classes.DecisionBox, classes[`DecisionBox${network}`]);
  const providerIconCalasses = classNames('cell shrink', classes.ProviderIcon);
  const uniqueId = idGenerator();

  const buttonVerb = actionType === IgModalActionEnum.CONNECT ? 'Connect' : 'Re-connect';

  return (
    <div className={decisionBoxClasses}>
      <div className={classes.Content}>
        {/* Header */}
        <div className={'grid-x margin-bottom-small-8'}>
          <div className={providerIconCalasses}>{network === 'Facebook' ? <FacebookIcon /> : <InstagramIcon />}</div>
          <div className={'cell auto'}>
            <h4>{title}</h4>
          </div>
        </div>

        {/* Pros */}
        <div className={'margin-top-small-8 margin-bottom-small-2'}>
          <div>PROS:</div>
          <ul>
            {pros.map((pro, index) => (
              <li key={index}>{pro}</li>
            ))}
          </ul>
        </div>

        {/* Cons */}
        <div className={'margin-top-small-2 margin-bottom-small-4'}>
          <div>CONS:</div>
          <ul>
            {cons.map((con, index) => (
              <li key={index}>{con}</li>
            ))}
          </ul>
        </div>

        {/* Button */}
        <div className={classes.ButtonWrapper} id={`decision-box-${network}-${uniqueId}`}>
          <Button
            type={'button'}
            variant={'solid'}
            size={'large'}
            color={network === 'Facebook' ? ButtonColorsEnum.facebook : ButtonColorsEnum.instagram}
            action={action}
            expanded>
            {buttonVerb} via {network}
          </Button>
        </div>
        <Tooltip
          type={'regular'}
          id={`tooltip-${network}-${uniqueId}`}
          pointer={true}
          position={'bottom'}
          autoZIndex={false}
          style={{ zIndex: scssVars['z-index-overmodal'] }}
          target={`#decision-box-${network}-${uniqueId}`}>
          <>{tooltip}</>
        </Tooltip>
      </div>
    </div>
  );
};
